module.exports = __webpack_public_path__ + "media/icons/envelope-003a6e6c.png";